<script lang="ts">
  /**
   * AudioNotification - Info banner when audio is unavailable
   * Non-intrusive notification that can be dismissed
   */

  import { fly } from 'svelte/transition';

  // Props
  interface Props {
    visible?: boolean;
    onDismiss?: () => void;
  }

  let {
    visible = false,
    onDismiss = () => {}
  }: Props = $props();
</script>

{#if visible}
  <div
    class="audio-notification"
    transition:fly={{ y: -20, duration: 300 }}
  >
    <div class="content">
      <span class="icon">🔇</span>
      <span class="message">
        Sound is currently unavailable. Letters will be shown visually instead.
      </span>
    </div>
    <button
      class="dismiss-button"
      onclick={onDismiss}
      aria-label="Dismiss notification"
    >
      ✕
    </button>
  </div>
{/if}

<style>
  .audio-notification {
    position: fixed;
    top: var(--space-lg);
    left: 50%;
    transform: translateX(-50%);
    z-index: 150;
    display: flex;
    align-items: center;
    gap: var(--space-md);
    padding: var(--space-md) var(--space-lg);
    background: rgba(251, 146, 60, 0.95);
    color: white;
    border-radius: var(--radius-md);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    max-width: 90%;
  }

  .content {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
  }

  .icon {
    font-size: 24px;
  }

  .message {
    font-size: var(--font-body);
    font-weight: 500;
  }

  .dismiss-button {
    padding: var(--space-xs);
    background: transparent;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s ease;
  }

  .dismiss-button:hover {
    opacity: 1;
  }

  /* Responsive */
  @media (max-width: 767px) {
    .audio-notification {
      top: var(--space-md);
      padding: var(--space-sm) var(--space-md);
    }

    .message {
      font-size: var(--font-sm);
    }

    .icon {
      font-size: 20px;
    }
  }
</style>
